module.exports = __webpack_public_path__ + "img/edit-table-icon.329788cc.svg";